import { render, staticRenderFns } from "./QuestionnaireStep.vue?vue&type=template&id=6b0f20ba&scoped=true&lang=pug"
import script from "./QuestionnaireStep.vue?vue&type=script&lang=ts"
export * from "./QuestionnaireStep.vue?vue&type=script&lang=ts"
import style0 from "./QuestionnaireStep.vue?vue&type=style&index=0&id=6b0f20ba&prod&lang=sass&scoped=true"
import style1 from "./QuestionnaireStep.vue?vue&type=style&index=1&id=6b0f20ba&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b0f20ba",
  null
  
)

export default component.exports